import store from '../store';
import util from '../util';

class Layer {
  constructor(config) {
    this.$config = {
      dimClick: true,
      esc: true,
      buttons: '',
      modifier: '',
      class:'base',
      ...config
    };

    this.$store = {
      state: {
        isActive: false,
        top: 0
      },

      dom: {
        html: $('html'),
        body: $('body'),
        layer: null,
        dim: null,
        contents: null,
        contentsWrap: null,
        closeButton: null
      },

      eventQ: {},

      uniqueId: `layer.${util.uniqueId()}`,

      autoplayVideo: config.autoplayVideo,

      slides: []
    };

    store(this.$store.uniqueId, this);

    this.layerStack = store('layerStack');

    this.renderLayer();

    this.cacheDom();

    if (this.$config.el) {
      this.setLayerContents($(this.$config.el));
    }

    this.setEvent();

    this.fireEvent('ready');
  }

  renderLayer() {
    this.$store.dom.layer = $(`<div class="promokit-layer promokit-layer--${this.$config.class}" data-store="${this.$store.uniqueId}" >
                                <button class="promokit-layer__close">닫기</button>
                                <div class="promokit-layer__contents-wrap" tabindex="-1">
                                  <div class="promokit-layer__contents"></div>
                                </div>
                                <div class="promokit-layer__dim"></div>
                              </div>`);

    if (this.$config.modifier) {
      this.$store.dom.layer.addClass(`promokit-layer--${this.$config.modifier}`);
    }

    this.$store.dom.body.append(this.$store.dom.layer);
  }

  setLayerContents(layerContents) {
    this.$store.dom.layer.find(`.promokit-layer__contents`).append(layerContents);

    if (this.$store.dom.layer.find('.promokit-slide').length > 0) {
      this.cacheSlideContents();
    }
  }

  cacheDom() {
    this.$store.dom.contentsWrap = this.$store.dom.layer.find(`.promokit-layer__contents-wrap`);
    this.$store.dom.contents = this.$store.dom.layer.find(`.promokit-layer__contents`);
    this.$store.dom.closeButton = this.$store.dom.layer.find(`.promokit-layer__close`);
  }

  cacheSlideContents() {
    _.forEach(this.$store.dom.layer.find('.promokit-slide'), (a) => {
      let slide = store($(a).data('store'));
      this.$store.slides.push(slide);
    });
  }

  setEvent() {
    $(document).on('keyup.promokit.layer', e => this.handleEscKey(e));

    if (this.$config.buttons) {$(document).on('click.promokit.layer', this.$config.buttons, e => this.handleOpenButton(e));}

    if (this.$config.dimClick) {this.$store.dom.contentsWrap.on('click.promokit.layer', e => this.handleDimClick(e));}

    this.$store.dom.closeButton.on('click.promokit.layer', e => this.handleCloseButton(e));

    this.$store.dom.layer.on('transitionend.promokit.layer', e => this.handleCloseEnd(e));
  }

  handleDimClick(e) {
    if ($(e.target).is(`.promokit-layer__contents-wrap`)) {
      e.preventDefault();
      this.close();
    }
  }

  handleOpenButton(e) {
    e.preventDefault();
    this.open();
  }

  handleCloseButton(e) {
    e.preventDefault();
    this.close();
  }

  handleEscKey(e) {
    if (this.layerStack.length < 1) return;

    if (e.keyCode !== 27) return;

    if (this.$store.uniqueId == this.layerStack[this.layerStack.length - 1].$store.uniqueId && this.$config.esc) {
      this.layerStack[this.layerStack.length - 1].close();
    }
  }

  handleCloseEnd() {
    if (this.$store.state.isActive) return;

    this.fireEvent('closeend');

    this.$store.dom.layer.hide();

    this.stopVideo();
  }

  autoplayVideo() {
    this.$store.autoplayVideo?.play();

    _.forEach(this.$store.slides, (slide) => {
      let video = slide.$store.autoplayVideo[slide.$store.nowIndex];
      video?.play();
    });
  }

  stopVideo() {
    $(this.$store.dom.layer).find('.promokit-video, .promokit-youtube')
                            .each(function() {
                              store($(this).data('store')).stop();
                            });
  }

  open(layerContents) {
    if (this.$store.state.isActive) return;
    this.$store.state.isActive = true;

    if (layerContents) {
      this.setLayerContents(layerContents);
    }

    if (this.layerStack.length > 0) {
      this.$store.dom.layer.css('z-index', this.layerStack[this.layerStack.length - 1].$store.dom.layer.css('z-index') + 1);
    }

    this.$store.dom.layer.show();

    if (this.checkLongContents) {
      this.$store.dom.contents.css({
        'padding-bottom': '100px'
      });
    }

    this.fireEvent('openstart');

    this.$store.dom.contentsWrap.focus();

    if (this.layerStack.length < 1) {
      let htmlTop = this.$store.dom.html.scrollTop();
      let bodyTop = this.$store.dom.body.scrollTop();

      this.$store.state.top = (htmlTop < 1 && bodyTop < 0) ? 0 : htmlTop > 0 ? htmlTop : bodyTop;

      this.$store.dom.html.css({
        'position': 'fixed',
        'margin-top': -this.$store.state.top,
        'width': '100%'
      });
    }

    this.$store.dom.layer.addClass('promokit-layer--active');
    this.$store.dom.contentsWrap.addClass('promokit-layer__contents-wrap--active');

    this.layerStack.push(this);

    this.autoplayVideo();

    this.fireEvent('openend');

    $(window).trigger('resize');
  }

  close() {
    if (!this.$store.state.isActive) return;
    this.$store.state.isActive = false;

    this.fireEvent('closestart');

    this.$store.dom.layer.removeClass('promokit-layer--active');
    this.$store.dom.contentsWrap.removeClass('promokit-layer__contents-wrap--active');

    this.layerStack.pop();

    if (this.layerStack.length === 0) {
      this.$store.dom.html.css({
        'position': '',
        'margin-top': '',
        'width': ''
      });

      $('html, body').scrollTop(this.$store.state.top);

      $(window).trigger('resize');
    }
  }

  fireEvent(event) {
    this.$store.eventQ[event] && this.$store.eventQ[event].forEach((fn) => {
      fn();
    });
  }

  on(e, fn) {
    if (!this.$store.eventQ[e]) {
      this.$store.eventQ[e] = [];
    }

    this.$store.eventQ[e].push(fn);
  }

  off(e) {
    delete this.$store.eventQ[e];
  }

  get checkLongContents() {
    return store('isMobile') && (this.$store.dom.contents.height() + 100 > window.innerHeight);
  }
}

export default Layer;
